import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { checkRequired, clientErrors } from '@/utils/errors';
import fields from '@/constants/fields';
import { states } from '@/constants/lifecycle';
import DatasetConditionContainer, {
  mapStateToProps,
  mapDispatchToProps,
} from '../components/DatasetConditionContainer';

export const validateWorkspaceAllowListContext = (datasetCondition, errors) => {
  checkRequired(
    datasetCondition.context.names,
    [fields.NAME],
    errors,
    'dataset.condition',
    'dataset.condition.validation.invalid.title',
    true,
  );
};

const WorkspaceAllowListCondition = ({
  datasetCondition,
  updateProperties,
  saveStatus,
  saveErrors,
}) => {
  const intl = useIntl();
  const namesError = clientErrors(saveErrors).find((e) => e.fields.includes(fields.NAME));
  const { names } = datasetCondition.context;

  return (
    <DatasetConditionContainer
      error={namesError}
      htmlFor="ADDUC_0006_names"
      labelId="dataset.condition.workspace.names.label"
    >
      <Dropdown
        id="ADDUC_0006_names"
        className="aridhia-workflows-dropdown"
        value={names}
        options={names.map((name) => ({ key: name, text: name, value: name }))}
        disabled={saveStatus === states.PENDING}
        fluid
        search
        selection
        multiple
        allowAdditions
        placeholder={intl.formatMessage({ id: 'dataset.condition.workspace.names.placeholder' })}
        error={!!namesError}
        onChange={(e, { value }) => { updateProperties({ names: value }, fields.NAME); }}
      />
    </DatasetConditionContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkspaceAllowListCondition);
